import React from 'react';
import styled from 'styled-components';
import { Flex, Text } from '../components';

const PolygonWrapper = styled(Flex)`
  align-items: flex-start;
  justify-content: center;
  margin: 6px 6px 0 0;
  width: 15px;
`;

function CollapsibleQuestions({
  children, title, open, handleClick,
}) {
  let polygon;
  if (open) {
    polygon = '/j/images/employee-onboarding/up-polygon.svg';
  } else {
    polygon = '/j/images/employee-onboarding/right-polygon.svg';
  }

  const renderWorksheet = () => <div>{children}</div>;

  return (
    <Flex column>
      <Flex style={{ paddingBottom: '20px' }} onClick={() => handleClick()}>
        <PolygonWrapper>
          <img src={polygon} />
        </PolygonWrapper>
        <Text style={{ color: '#0D8CE6' }}>{title}</Text>
      </Flex>
      {open && renderWorksheet()}
    </Flex>
  );
}

export default CollapsibleQuestions;
